"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * @param {V2.ExchangeDataGrouping} _
 * @returns {V2.ExchangePolicyGroupInfo}
 */
function stationExchangeTerms(_) {
  // eslint-disable-line no-unused-vars
  return {
    icon: "exchange-alt",
    method: "!refund-and-exchange.content.exchange.station.method",
    method_simplified: "!refund-and-exchange.content.exchange.station.method.simplified"
  };
}

exports.default = stationExchangeTerms;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92Mi9leGNoYW5nZXMvc3RhdGlvbi1leGNoYW5nZS5qcyJdLCJuYW1lcyI6WyJzdGF0aW9uRXhjaGFuZ2VUZXJtcyIsIl8iLCJpY29uIiwibWV0aG9kIiwibWV0aG9kX3NpbXBsaWZpZWQiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFJQSxTQUFTQSxvQkFBVCxDQUE4QkMsQ0FBOUIsRUFBaUM7QUFDL0I7QUFDQSxTQUFPO0FBQ0xDLFVBQU0sY0FERDtBQUVMQyxZQUFRLHNEQUZIO0FBR0xDLHVCQUFtQjtBQUhkLEdBQVA7QUFLRDs7a0JBRWNKLG9CIiwiZmlsZSI6InN0YXRpb24tZXhjaGFuZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAdHMtY2hlY2tcblxuLyoqXG4gKiBAcGFyYW0ge1YyLkV4Y2hhbmdlRGF0YUdyb3VwaW5nfSBfXG4gKiBAcmV0dXJucyB7VjIuRXhjaGFuZ2VQb2xpY3lHcm91cEluZm99XG4gKi9cbmZ1bmN0aW9uIHN0YXRpb25FeGNoYW5nZVRlcm1zKF8pIHtcbiAgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby11bnVzZWQtdmFyc1xuICByZXR1cm4ge1xuICAgIGljb246IFwiZXhjaGFuZ2UtYWx0XCIsXG4gICAgbWV0aG9kOiBcIiFyZWZ1bmQtYW5kLWV4Y2hhbmdlLmNvbnRlbnQuZXhjaGFuZ2Uuc3RhdGlvbi5tZXRob2RcIixcbiAgICBtZXRob2Rfc2ltcGxpZmllZDogXCIhcmVmdW5kLWFuZC1leGNoYW5nZS5jb250ZW50LmV4Y2hhbmdlLnN0YXRpb24ubWV0aG9kLnNpbXBsaWZpZWRcIlxuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBzdGF0aW9uRXhjaGFuZ2VUZXJtcztcbiJdfQ==